import { Box, StepLabel, Stepper, styled, Typography } from '@mui/material';

import { isMobile } from 'utils/isMobile';

export const StepperComponentWrapper = styled(Box)({});

export const StyledStepperLabel = styled(StepLabel)({
  fontFamily : 'Montserrat',
});

export const StyledStepper = styled(Stepper)(({ theme, maxWidth }) => ({
  width                      : '100%',
  maxWidth                   : !maxWidth ? '376px' : maxWidth,
  margin                     : '26px auto 13px',
  '& .MuiStepConnector-root' : {
    '&.Mui-active' : {
      '& .MuiStepConnector-line' : {
        borderColor : '#A3CF5E',
      },
    },
    '&.Mui-completed' : {
      '& .MuiStepConnector-line' : {
        borderColor : '#A3CF5E',
      },
    },
    '&.Mui-disabled' : {
      '& .MuiStepConnector-line' : {
        borderColor : '#EAEAEA',
      },
    },
    '& .MuiStepConnector-line' : {
      borderTopWidth : '6px',
    },
  },
  '& .MuiStepIcon-root' : {
    fontSize       : '1.75rem',
    '&.Mui-active' : {},
  },
}));

export const StepTitle = styled(Typography)(({ theme }) => ({
  fontSize   : isMobile() ? '22px' : '32px',
  fontWeight : '700',
  lineHeight : '42px',
  textAlign  : 'center',
  color      : '#A3CF5E',
}));
